import styled from 'styled-components';
import { Checkbox, Tooltip } from 'antd';
import { useNavigate, Link } from 'react-router-dom';
import { valueToObject } from 'Utils/UtilityFunctions';
import { actions as flurryActions } from 'Slice/HelperSlice';
import { useDispatch } from 'react-redux';
import { INDUSTRY_NEWS_ROUTE, SERVICELINE_ACCOUNTNEWS_ROUTE, SERVICELINE_NEWS_ROUTE } from 'Utils/Constants';
import classNames from 'classnames';
import {
  primaryColor, primaryFont, secondaryFont, wMedium, primaryHeadingColor,
  maxWidth, retina, minWidthApp, SecondaryColor,
  textBlack,
  wMLight,
  minExtraLargeScreen,
  maxTablet,
  maxMobile,
} from '../../../Utils/utilsStyle';
import BannerWidget from './BannerWidget';
import GlobalButton from './GlobalButton';

type Props = {
  removeButton?: boolean
  articleBanner?: string,
  articleText?: string,
  isAdded?: boolean,
  id?: number
  checked?: boolean
  followLoading?: boolean
  isServicelines?: boolean
  pagination?: boolean
  setChecked?: (a: boolean) => void
  followIndustry?: () => void
  showUnfollow?: boolean
  unFollowingIndustry?: () => void
  isSearchPage?: boolean
  isRecommended?: boolean,
  inGlobalSearch?: boolean,
} & typeof defaultProps;

const defaultProps = {

  articleBanner: '',
  removeButton: false,
  articleText: '',
  isAdded: false,
  id: 0,
  checked: false,
  followLoading: false,
  isServicelines: false,
  pagination: false,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setChecked: (a: boolean) => { },
  followIndustry: () => { },
  showUnfollow: false,
  unFollowingIndustry: () => { },
  isSearchPage: false,
  isRecommended: false,
  inGlobalSearch: false,
};

const Wrapper = styled.div<{ disabled: boolean }>`
  &.industriesSearch {
    &.company-item {
      padding-bottom: 0px;
      .exceptButtonContent {
        .export-widget-industries {
          margin-bottom: 6px;
          @media all and (min-width: ${minExtraLargeScreen}) {
            margin-bottom: 4px;
          }
          @media all and (max-width: ${maxTablet}) {
            margin-bottom: 4px;
          }
        }
        .companyName {
          color: ${textBlack};
          text-align: center;
          font-family: ${primaryFont};
          font-size: 16px;
          font-weight: ${wMLight};
          line-height: 18px;
          letter-spacing: -0.52px;
          margin-bottom: 4px;
          @media all and (min-width: ${minExtraLargeScreen}) {
            font-size: 20px;
            line-height: 22px;
            letter-spacing: -0.746px;
          }
          @media all and (max-width: ${maxWidth}), ${retina} {
            font-size: 16px;
            line-height: 18px;
            letter-spacing: -0.52px;
          }
          @media all and (max-width: ${maxTablet}) {
            font-size: 14px;
            line-height: 16px;
            letter-spacing: -0.414px;
          }
        }
        .global-btn-industries {
          margin-top: 0px;
          display: flex;
          justify-content: center;
          align-items: center;
          .button-follow {
            display: inline-flex;
            height: 24px;
            width: 84px;
            padding: 4px 14px;
            justify-content: center;
            align-items: center;
            gap: 10px;
            border-radius: 16px;
            text-align: center;
            font-family: ${primaryFont};
            font-size: 14px;
            font-weight: ${wMLight};
            line-height: 17px;
            @media all and (min-width: ${minExtraLargeScreen}) {
              height: 34px;
              width: 120px;
              font-size: 20px;
              line-height: 23px;
              border-radius: 22px;
            }
            @media all and (max-width: ${maxWidth}) , ${retina} {
              height: 24px;
              width: 84px;
              border-radius: 16px;
              font-size: 14px;
              line-height: 17px;
              padding: 4px 14px;
            }
            @media all and (max-width: ${maxTablet}) {
              height: 20px;
              width: 72px;
              padding: 3px 12px;
              border-radius: 16px;
              font-size: 12px;
              line-height: 15px;
            }
            @media all and (max-width: ${maxMobile}) {
              height: 20px;
              width: 64px;
              font-size: 12px;
              line-height: 15px;
              padding: 3px 12px;
            }
          }
        }
      }
    }
  }
  max-width: 205px;
  width: 205px;
  position: relative;
  cursor: pointer;
  padding-bottom: 30px;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    max-width: 162px;
    width: 162px;
  }
  .exceptButtonContent {
    opacity: ${(props) => {
    if (props.disabled) return '0.5';
    return '1';
  }};
  cursor: pointer;
  }
  span {
    font-size: 18px;
    color: ${primaryHeadingColor};
    font-weight: 800;
    font-family: ${secondaryFont};
    letter-spacing: -0.45px;
    line-height: 1.111 !important;
    text-align: center;
    cursor: pointer;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 16px;
      line-height: 24px !important;
      margin-bottom: 2px;
    }
    a {
    color: ${primaryHeadingColor};
    }
    @media all and (max-width: ${minWidthApp}){
      font-size: 13px;
      line-height: 16px !important;
    }
  }
  p {
    font-size: 11px;
    color: #7E7E7E !important;
    font-weight: ${wMedium};
    font-family: ${primaryColor};
    font-family: ${primaryFont};
    letter-spacing: -0.75px;
    margin-left: 10px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 9px;
    }
  }
  .deleteButton {
    position: absolute;
    top: -2px;
    right: -6px;
    width: fit-content;
    background-color: transparent;
    border: none;
    .ant-checkbox {
      .ant-checkbox-inner {
        border: 2px solid ${primaryHeadingColor};
        margin: 0px;
      }
    }
    :hover {
      .ant-checkbox-checked {
        .ant-checkbox-inner {
          background-color: white !important;
          border: 2px solid ${primaryColor} !important;
        }
      }
    }
  }
  .global-btn-industries {
     margin-top: 20px;
    .button-follow {
      border: 2px solid ${SecondaryColor};
    }
     cursor: pointer;
    .button-follow {
     margin: 0 auto;
    }
  }
`;

const IndustriesWidget = function IndustriesWidget(props: Props) {
  const {
    removeButton,
    articleBanner,
    articleText,
    isAdded,
    id,
    checked,
    setChecked,
    followIndustry,
    followLoading,
    isServicelines,
    pagination,
    showUnfollow,
    unFollowingIndustry,
    isSearchPage,
    isRecommended,
    inGlobalSearch,
  } = props;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const serviceLineURL = pagination ? `${SERVICELINE_NEWS_ROUTE}${id}?name=${articleText}` : `${SERVICELINE_ACCOUNTNEWS_ROUTE}${id}?name=${articleText}`;
  const industryURL = `${INDUSTRY_NEWS_ROUTE}${id}`;
  const host = window.location.href;

  const handleCardClicked = () => {
    if (!removeButton) {
      if (isServicelines) {
        navigate(serviceLineURL);
      } else {
        navigate(industryURL);
        dispatch(flurryActions.callFlurryEvent(
          valueToObject('open_industry_view', 0, {
            industry_id: id,
            host,
          }),
        ));
      }

      if (isSearchPage) {
        dispatch(flurryActions.callFlurryEvent(
          valueToObject('searchPage_industry_clicked', 0, {
            industry_id: id,
            industry_name: articleText,
            host,
          }),
        ));
      }
    }
  };
  const followingIndustry = () => {
    followIndustry();
    if (isSearchPage) {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('searchPage_indsutry_follow', 0, {
          industry_id: id,
          industry_name: articleText,
          host,
        }),
      ));
    }
    if (isRecommended) {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('follow_industries_recommendedIndustries', 0, {
          industry_id: id,
          host,
        }),
      ));
    }
  };
  const unfollow = () => {
    unFollowingIndustry();
    if (isSearchPage) {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('searchPage_indsutry_unfollow', 0, {
          industry_id: id,
          industry_name: articleText,
          host,
        }),
      ));
    }
  };
  return (
    <Wrapper
      disabled={removeButton}
      className={classNames('company-item', {
        industriesSearch: inGlobalSearch,
      })}
    >
      <label className="check_label" htmlFor={`${id}`}>
        <div className="exceptButtonContent">
          <BannerWidget
            logo={articleBanner}
            widthSm="160px"
            heightSm="112px"
            onClick={handleCardClicked}
          />
          <Tooltip
            trigger="hover"
            placement="top"
            getPopupContainer={(e: HTMLElement) => e}
            className="triggers-bullet-tooltip person-designation-tip"
            color="#fff"
            title={articleText}
            arrow={false}
          >
            <span
              className="primary-color companyName text-truncate-one-line"
              role="button"
              aria-label={articleText}
              tabIndex={0}
            >
              <Link to={isServicelines ? serviceLineURL : industryURL}>
                {articleText}
              </Link>
            </span>
          </Tooltip>
          {
            !isAdded
            && (
              <div className="global-btn-industries">
                <GlobalButton
                  title={followLoading ? 'Following' : 'Follow'}
                  textColor="#ffffff"
                  bgColor="#001760"
                  borderRadius="25px"
                  innerSpace="8px 20px"
                  PaddingSm="4px 16px 3px 16px"
                  buttonClassName="button-follow"
                  disabled={followLoading}
                  onButtonClick={followingIndustry}
                />
              </div>
            )
          }
          {isAdded && showUnfollow
            ? (
              <div className="global-btn-industries">
                <GlobalButton
                  title="Unfollow"
                  textColor="#001760"
                  bgColor="transparent"
                  borderRadius="25px"
                  innerSpace="8px 20px"
                  PaddingSm="4px 16px 3px 16px"
                  buttonClassName="button-follow"
                  onButtonClick={unfollow}
                />
              </div>

            ) : null}
        </div>
        {
          removeButton
            ? (
              <Checkbox
                id={`${id}`}
                checked={checked}
                className="deleteButton"
                onClick={() => setChecked(checked)}
              />
            )
            : null
        }
      </label>
    </Wrapper>
  );
};

IndustriesWidget.defaultProps = defaultProps;
export default IndustriesWidget;
